export default (function (_ref) {
  var wrapper = _ref.wrapper;
  return {
    visitor: {
      Program: {
        leave: function leave(node) {
          wrapper(this, node);
        }
      }
    }
  };
});